export enum CorporatePartPackageType {
  PACKAGED = 'packaged',
  INDIVIDUAL = 'individual',
  CUT_TO_LENGTH = 'cut to length',
  FIXED_QUANTITY = 'fixed quantity',
  TIME = 'time',
}

export const PartPackageTypeLabel: Record<CorporatePartPackageType, string> = {
  [CorporatePartPackageType.PACKAGED]: 'Packaged',
  [CorporatePartPackageType.INDIVIDUAL]: 'Individual',
  [CorporatePartPackageType.CUT_TO_LENGTH]: 'Cut To Length',
  [CorporatePartPackageType.FIXED_QUANTITY]: 'Fixed Quantity',
  [CorporatePartPackageType.TIME]: 'Time',
};

export enum CorporatePartStatus {
  ACTIVE = 'active',
  OBSOLETE = 'obsolete',
  USE_UP = 'use up',
}

export const PartStatusLabel: Record<CorporatePartStatus, string> = {
  [CorporatePartStatus.ACTIVE]: 'Active',
  [CorporatePartStatus.OBSOLETE]: 'Obsolete',
  [CorporatePartStatus.USE_UP]: 'Use Up',
};

export enum CorporatePartTaaStatus {
  COMPLIANT = 'compliant',
  UNKNOWN = 'unknown',
  NOT_COMPLIANT = 'not compliant',
}

export const PartTaaStatusLabel: Record<CorporatePartTaaStatus, string> = {
  [CorporatePartTaaStatus.COMPLIANT]: 'Compliant',
  [CorporatePartTaaStatus.UNKNOWN]: 'Unknown',
  [CorporatePartTaaStatus.NOT_COMPLIANT]: 'Not Compliant',
};

export enum CorporateSourceType {
  EXTERNAL = 'external',
  SELF = 'self',
}
